import { render, staticRenderFns } from "./cellDtNumberType.vue?vue&type=template&id=6f80548e&scoped=true"
import script from "./cellDtNumberType.vue?vue&type=script&lang=js"
export * from "./cellDtNumberType.vue?vue&type=script&lang=js"
import style0 from "./cellDtNumberType.vue?vue&type=style&index=0&id=6f80548e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f80548e",
  null
  
)

export default component.exports